export const findPartnerName = data => {
  const [enterprise_partner] = data?.enterprise_partners || []
  return [enterprise_partner?.display_name]
}

export const findClientNames = data => {
  return data?.enterprise_clients?.map(client => client.name)
}
